import React from 'react';

interface Props
  extends Omit<React.SVGAttributes<SVGElement>, 'width' | 'height'> {
  size?: number | string;
}

const ArrowRight: React.FunctionComponent<Props> = (props) => {
  const { size = 24, ...restProps } = props;
  return (
    <svg
      {...restProps}
      width={size}
      height={size}
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M13.4773 9.16689L9.00732 4.69689L10.1857 3.51855L16.6673 10.0002L10.1857 16.4819L9.00732 15.3036L13.4773 10.8336H3.33398V9.16689H13.4773Z'
        fill='white'
      />
    </svg>
  );
};

export default ArrowRight;
